export default __webpack_public_path__ + "static/media/placeholder-img.6e4e8d72.svg";